<template lang="html">
  <div>Dashboard</div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
